import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CalculatorPage from "@/pages/Calculator";
import ProBudget from "@/pages/ProBudget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CalculatorPage />} />
          <Route path="/pro" element={<ProBudget />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
